import { FieldCompanyNamespace } from "../../env-config";
import localisations from "shell/localisation";

var displayedAlert = false;

export function getFieldCompanyId(user: any): number {
    var fieldCompanyId = 0;

    var namespace = FieldCompanyNamespace();

    if (noNamespaceInConfiguraton(namespace)) {
        showAlert(localisations.services.fieldCompanyService.noNamespaceInConfigText);
        return fieldCompanyId;
    }

    var fieldCompanyIds: Array<number> = user ? user[namespace] : [];

    if (noCompanyNamespaceOrFieldCompanyIds(fieldCompanyIds)) {
        showAlert(localisations.services.fieldCompanyService.noFieldCompanyForLoggedInUserText);
        return fieldCompanyId;
    }

    if (moreThanOneFieldCompanyId(fieldCompanyIds)) {
        if (!displayedAlert) {
            showAlert(
                localisations.services.fieldCompanyService.moreThanOneFieldCompanyText.replace(
                    "__fieldCompanyId__",
                    fieldCompanyIds[0].toString()
                )
            );
            displayedAlert = true;
        }

        return firstCompanyIdInList(fieldCompanyIds);
    }

    return firstCompanyIdInList(fieldCompanyIds);
}

export function listFieldCompanyIds(user: any): number[] {
    const defaultFieldCompanyIds: number[] = [];

    var namespace = FieldCompanyNamespace();

    if (noNamespaceInConfiguraton(namespace)) {
        return defaultFieldCompanyIds;
    }

    var fieldCompanyIds: Array<number> = user ? user[namespace] : [];

    if (noCompanyNamespaceOrFieldCompanyIds(fieldCompanyIds)) {
        return defaultFieldCompanyIds;
    }

    return fieldCompanyIds;
}

function noNamespaceInConfiguraton(namespace: string): boolean {
    return !namespace;
}

function noCompanyNamespaceOrFieldCompanyIds(fieldCompanyIds: number[]): boolean {
    return !fieldCompanyIds?.length;
}

function moreThanOneFieldCompanyId(fieldCompanyIds: number[]): boolean {
    return fieldCompanyIds.length > 1;
}

function firstCompanyIdInList(fieldCompanyIds: number[]): number {
    return fieldCompanyIds[0];
}

function showAlert(message: string): void {
    window.alert(message);
}
